import React from "react";

const ERPDashboardInfo = () => {
  const features = [
    { feature: "A Workflow Tool / Full Workflow Engine", your: "✅", tally: "❌" },
    { feature: "Document / Files management system", your: "✅", tally: "❌" },
    { feature: "Cloud multi-user ERP (browser + mobile)", your: "✅", tally: "❌ (desktop-only)" },
    { feature: "Task / Alerts automation engine", your: "✅", tally: "❌" },
    { feature: "Stats dashboard (real-time)", your: "✅", tally: "❌" },
    { feature: "Cost analytics (real-time)", your: "✅", tally: "❌" },
    { feature: "Attendance system", your: "✅", tally: "❌" },
    { feature: "AI logic for operations", your: "✅", tally: "❌" },
    { feature: "Role-based control", your: "✅", tally: "⚠️ basic" },
    { feature: "FAST (cloud speed, real-time sync)", your: "✅", tally: "❌ local only" },
    { feature: "SECURE (audit logs, 2FA, cloud backups)", your: "✅", tally: "❌" },
    { feature: "AUDITABLE (heartbeat, pdfs, excel, searchable sections)", your: "✅", tally: "❌" },
    { feature: "Scalable data (millions / billions of rows)", your: "✅", tally: "❌" },
    { feature: "Business insights (AI dashboards, Structured Data Analytics)", your: "✅", tally: "❌" },
    { feature: "End-to-end business operations", your: "✅", tally: "❌" },
    { feature: "Cloud Multi-User Ops", your: "✅", tally: "❌" },
    { feature: "Mobile Access (Safari, Chrome, etc)", your: "✅", tally: "❌" },
    { feature: "Ledgers & vouchers", your: "✅ (included)", tally: "✅ (main job)" },
    { feature: "Instant New features (1-2 Days)", your: "✅ (included)", tally: "❌ (Expensive, slow)" },
  ];

  const keyBenefits = [
"📱 Mobile Attendance → Attendance Section → One Click",
"📸 Uploading A Document → Camera → Document Storage → Saved",
"⚡ Dashboard → Numbers Appear Instantly",
"🛡 Secure, Real-Time, Multi-User Operations",
"⏱ Instant Search, Instant Updates, No Delays",
"✅ Alerts, Reminders, And AI-Assisted Operations Prevent Errors",
"🌐 Works Across Companies, Locations, And Devices",
  ];

  const calloutItems = [
    "Tests performance under real load",
    "Trains staff without risk",
    "Confirms data is correct",
    "Builds confidence",
    "Prevents disasters on day 1",
  ];

  return (
    <div className="p-6 bg-white rounded-lg shadow-md space-y-6">
      <h2 className="text-2xl font-bold text-yellow-600">Why Your ERP is Better than TallyPrime</h2>

     {/* Flex container for table + side info */}
<div className="flex flex-col lg:flex-row gap-6">
  
  {/* Feature Table */}
  <div className="flex-1 overflow-x-auto">
    <table className="min-w-full border border-gray-300 text-sm">
      <thead className="bg-gray-100">
        <tr>
          <th className="border px-4 py-2 text-left">Feature / Capability</th>
          <th className="border px-4 py-2 text-center">Your System</th>
          <th className="border px-4 py-2 text-center">Tally Prime</th>
        </tr>
      </thead>
      <tbody>
        {features.map((f, idx) => (
          <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
            <td className="border px-4 py-2 font-medium">{f.feature}</td>
            <td className="border px-4 py-2 text-center">{f.your}</td>
            <td className="border px-4 py-2 text-center">{f.tally}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

{/* Side info (Key Benefits + Callout) */}
<div className="flex-1 flex flex-col gap-4 h-full">
  
  {/* Key Benefits */}
  <div className="flex-1 bg-yellow-50 p-6 rounded-lg shadow-sm text-sm flex flex-col min-h-full">
    <h3 className="font-semibold text-gray-700 mb-3 text-lg">Key Benefits</h3>
    <div className="flex-1 flex flex-col gap-3 overflow-auto">
      {keyBenefits.map((b, idx) => (
        <span
          key={idx}
          className="bg-white px-3 py-2 rounded shadow-sm text-sm md:text-base font-medium"
        >
          {b}
        </span>
      ))}
    </div>
  </div>

{/* Billion-dollar company callout as card */}
<div className="flex-1 bg-yellow-50 p-6 rounded-lg shadow-sm flex flex-col min-h-full">
  <p className="font-semibold mb-3 text-lg">
    Even billion-dollar companies run old and new systems side-by-side for 4-6 weeks to ensure:
  </p>
  <div className="flex-1 overflow-auto">
    <ul className="list-disc list-outside space-y-2 text-sm md:text-base">
      {calloutItems.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  </div>
</div>


</div>


</div>

    </div>
  );
};

export default ERPDashboardInfo;
